import {
    getModuleConfigFromFile,
    getDerivedData as getDerivedDataUser,
} from "./getUserData";
import { AppModel, DerivedData } from "./types/AutoModuleTypes";

function createAutoProcessor(
    getDerivedData: (dataModel: AppModel) => DerivedData,
): (dataModel: AppModel) => DerivedData {
    const derivedDataGetter = (dataModel: AppModel): DerivedData => {
        return {
            getModuleConfig: getModuleConfigFromFile,
            ...getDerivedData(dataModel),
        };
    };
    return derivedDataGetter;
}

export const getDerivedData = createAutoProcessor(getDerivedDataUser);
